import { Modal, PrimaryButton, SecondaryButton } from '@dot/design-system';

import * as SC from './InfoModalStyles';
import { useInfoModalContent } from './useInfoModalContent';

import AlertIcon from '@/assets/icons/alert.svg?react';
import { toggleInfoModalAction } from '@/providers/app-provider/actions';
import { useAppContext } from '@/providers/app-provider/context';

export const InfoModal = () => {
  const {
    dispatch,
    state: { infoModal },
  } = useAppContext();

  const isInfoModalOpen = Boolean(infoModal);

  const modalRootElement = document.getElementById('modal-root');

  if (!modalRootElement) {
    throw new Error('Modal root element not found');
  }

  function closeModal() {
    dispatch(toggleInfoModalAction(null));
  }

  const { heading, primaryButton, secondaryButton, text } = useInfoModalContent(closeModal, isInfoModalOpen);

  return (
    <>
      <Modal isOpen={isInfoModalOpen} modalRoot={modalRootElement} onClose={closeModal}>
        <SC.ModalContent $colorVariant={'light'} id={'info_modal'}>
          <SC.ModalBody>
            <SC.IconWrapper>
              <AlertIcon />
            </SC.IconWrapper>
            <SC.Heading as="h3">{heading}</SC.Heading>
            <SC.Text>{text}</SC.Text>
          </SC.ModalBody>
          <SC.ButtonsContainer>
            {secondaryButton && (
              <SecondaryButton data-test-id={secondaryButton.testId} onClick={secondaryButton.onClick}>
                {secondaryButton.text}
              </SecondaryButton>
            )}
            <PrimaryButton data-test-id={primaryButton.testId} onClick={primaryButton.onClick}>
              {primaryButton.text}
            </PrimaryButton>
          </SC.ButtonsContainer>
        </SC.ModalContent>
      </Modal>
    </>
  );
};
